const o={onSelectResult:void 0,accessors:void 0};export{o as defaultCosmographSearchConfig};
//# sourceMappingURL=config.js.map
